import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { FRAGMENT_JOB_ID, waitForJobWithEntityResult } from 'src/graphql/job';
import { getGqlFragmentName, getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_PROJECT_LONG_FORM_SECTION } from './schema';

export const generateLongFormSection = async (
  {
    projectId,
    sectionId,
    assetType,
    generationTool,
    instruction,
    promptInstructionsData,
    urlExtractions,
    mediaGenerationParameters,
    newSection,
    debugAcPrompt,
  },
  options = null
) => {
  const resultFragment = FRAGMENT_PROJECT_LONG_FORM_SECTION;
  const fragment = options?.async ? FRAGMENT_JOB_ID : resultFragment;
  const mutation = gql`
    mutation GenerateLongFormBuilderSection(
      $async: Boolean
      $projectId: ID!
      $sectionId: ID!
      $assetType: AssetTypeEnum!
      $generationTool: GenerationToolEnum!
      $instruction: Instruction
      $promptInstructionsData: PromptInstructionData
      $urlExtractions: [UrlExtractionInput!]
      $mediaGenerationParameters: MediaGenerationParametersInput
      $newSection: Boolean
      $debugAcPrompt: String
    ) {
      generateLongFormBuilderSection(
        async: $async
        projectId: $projectId
        sectionId: $sectionId
        assetType: $assetType
        generationTool: $generationTool
        instruction: $instruction
        promptInstructionsData: $promptInstructionsData
        urlExtractions: $urlExtractions
        mediaGenerationParameters: $mediaGenerationParameters
        newSection: $newSection
        debugAcPrompt: $debugAcPrompt
      ) {
        ...${getGqlFragmentName(fragment)}
      }
    }
    ${fragment}
  `;

  const variables = {
    async: options?.async ?? false,
    projectId,
    sectionId,
    assetType,
    generationTool,
    instruction,
    promptInstructionsData,
    urlExtractions,
    mediaGenerationParameters,
    newSection,
    debugAcPrompt,
  };

  const response = await executeGqlMutation({
    mutation,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });

  const result = getSingleProp(response.data);
  if (!options?.async) {
    return result;
  }

  return waitForJobWithEntityResult(result.id, resultFragment, {
    abortSignal: options?.abortSignal,
  });
};
